
import { dataLayerPageView } from "./Pages/Root/GoogleAdServices";
import { FormSubmitToggle } from "./Pages/Root/FormSubmitToggle";
import { HttpRequest } from "./Pages/httpRequest";
import { IssueLogger } from "./Pages/Root/deferred/issueLogger";
import { Modal } from "./Pages/Root/modal";
import { UrlParser } from "./Pages/Root/url-parser";
import {
    BrowserClient,
    browserApiErrorsIntegration,
    browserProfilingIntegration,
    breadcrumbsIntegration,
    browserSessionIntegration,
    dedupeIntegration,
    defaultStackParser,
    functionToStringIntegration,
    getCurrentScope,
    globalHandlersIntegration,
    httpContextIntegration,
    makeFetchTransport,
    linkedErrorsIntegration,
    browserTracingIntegration,
    thirdPartyErrorFilterIntegration
} from "@sentry/browser";

import "./Pages/Root/Deferred/google.certified.shops";
import "./Validators/validator-base";
import "./Validators/channel-islands";
import "./Validators/check-gift-card-added";
import "./Validators/compare-case-insensitive";
import "./Validators/email-untrimmed";
import "./Validators/must-be-checked";
import "./Validators/payment-type";
import "./Validators/required-if-checkbox";
import "./Validators/required-if-value";
import "./Validators/stringlength-if-value";
import "./Validators/summarise-adyen-errors";
import "./Validators/turnstile";
import "./Validators/validation-bootstrap";
import "./Pages/Root/checkboxes";
import "./Pages/Root/sign-in-base";
import "./Pages/Root/magicscroll";
import "./Pages/Root/scroll-products";

// Attach objects to window for global accessibility and to ensure exported:
(window as any).dataLayerPageView = dataLayerPageView;
(window as any).FormSubmitToggle = FormSubmitToggle;
(window as any).HttpRequest = HttpRequest;
(window as any).IssueLogger = IssueLogger;
(window as any).Modal = Modal;
(window as any).UrlParser = UrlParser;

const client = new BrowserClient({
    dsn: "https://3e234a76712f4c489c7528e115641c1c@o353332.ingest.us.sentry.io/2547060",
    transport: makeFetchTransport,
    stackParser: defaultStackParser,
    integrations: [
        breadcrumbsIntegration(),
        browserApiErrorsIntegration(),
        browserProfilingIntegration(),
        browserSessionIntegration(),
        browserTracingIntegration(),
        dedupeIntegration(),
        functionToStringIntegration(),
        globalHandlersIntegration(),
        httpContextIntegration(),
        linkedErrorsIntegration(),
        // Ignores errors that do not contain the flag from our rollup bundling.
        // See https://docs.sentry.io/platforms/javascript/configuration/filtering/#using-thirdpartyerrorfilterintegration
        thirdPartyErrorFilterIntegration({
            filterKeys: ["35D028C7-742F-4FAA-A91D-56495483350D"],
            behaviour: "drop-error-if-contains-third-party-frames"
        }),
    ],
    tracesSampleRate: 0.2,
    tracePropagationTargets: ["https://www.outdoorandcountry.co.uk"],
});

getCurrentScope().setClient(client);
client.init();